import { useContext, useEffect, useMemo, useState } from "react";
import nextId from "react-id-generator";
import { GlobalContext } from "../global-state";

export type UseModalType = ReturnType<typeof useModal>;
export function useModal(initialState?: boolean): {
  isActive: boolean;
  open: () => void;
  close: () => void;
} {
  const [isActive, setIsActive] = useState<boolean>(initialState || false);
  const close = () => setIsActive(false);
  const open = () => setIsActive(true);

  return { isActive, open, close };
}

export const useGlobalState = () => useContext(GlobalContext);

export const useMount = (func: () => void) => {
  useEffect(() => {
    func();
    //eslint-disable-next-line
  }, []);
};

export const useSubmitting = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  return {
    isSubmitting,
    startSubmitting: () => setIsSubmitting(true),
    stopSubmitting: () => setIsSubmitting(false),
  };
};

// リスト要素に使用するkeyに、リストのデータ側にIDなどユニークな値が無い場合に使用するcustom hook
export const useListKeys = (list: unknown[]): string[] => {
  return useMemo<string[]>(() => {
    return list.map(() => {
      return nextId("list-keys-");
    });
  }, [list]);
};
